// extracted by mini-css-extract-plugin
export default {"dataWrp":"PlantSiteDataBlock_dataWrp__wxT5p","dataLabel":"PlantSiteDataBlock_dataLabel__aldOO","dataValueNumber":"PlantSiteDataBlock_dataValueNumber__1Nd96"};